/**
 * „Neu im ERP“ (Story 1.99): Link einer Neuerung (`/aufgaben?gruppe=cases`) in Ziel und Suchparameter zerlegen, damit der
 * Router die Seite mit ihren Parametern öffnet.
 */
export function releaseNoteLink(href: string): { to: string; search: Record<string, string> } {
  const [path, query] = href.split('?', 2);
  return { to: path || '/', search: Object.fromEntries(new URLSearchParams(query ?? '')) };
}

/**
 * Abfrage der Seite „Neu im ERP“. Die Glocke macht sie nach „gesehen“ ungültig, damit „Neu“ auf der offenen Seite ohne
 * Neuladen verschwindet (Story 1.113).
 */
export const RELEASE_NOTES_KEY = ['release-notes'] as const;
